export function getJobTypes() {
  const jobTypes = {
    job: { id: "job", label: "Lägg ut uppdrag" },
    worker: { id: "worker", label: "Tillgänglig hantverkare" },
  };
  return jobTypes;
}

export function getJobTypeById(jobTypeId) {
  return getJobTypes()[jobTypeId];
}
